import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=fdb449ec&scoped=true"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"
import style0 from "./IconLink.vue?vue&type=style&index=0&id=fdb449ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb449ec",
  null
  
)

export default component.exports